/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { expensesAnalyzerRedirectSubscribersExpenses } from '../../../../../pages/PageExpensesAnalyzer/pageExpensesAnalyzerActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';

const useTableFooterButtonShowSubsExpenses = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__button btn__show-subs_expenses',
        dataName: 'showSubsExpenses',
        icon: icons.profileIconSmall,
        id: AccessComponentKeyEnum.FooterButtonShowSubsExpenses,
        onboarding: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonShowSubsExpenses,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonShowSubsExpenses),

        onClick: useCallback(() => {
            dispatch(expensesAnalyzerRedirectSubscribersExpenses());
        }, [dispatch]),
    };
};

export default useTableFooterButtonShowSubsExpenses;
